import { FormattedMessageHelper } from '../../shared/helpers/internationalization';
import React from 'react';
import { addModifiers } from '../../shared/helpers';

interface FeaturesSectionProps {
  isLoggedIn: boolean;
}
export function FeaturesSection({ isLoggedIn }: FeaturesSectionProps) {
  return (
    <div className="consultant-landing__section-container">
      <div className="consultant-landing__inner">
        <div className="consultant-landing__features">
          <h2 className="consultant-landing__title consultant-landing__title--h2">
            <FormattedMessageHelper id="consultantLanding.featuresHeader" />
          </h2>

          <div className="consultant-landing__features-grid">
            <Feature
              key="consultantLanding.additionalFields"
              header="consultantLanding.additionalFields"
              content={'consultantLanding.exploreAdditional'}
              icon="data"
            />
            <Feature
              key="consultantLanding.moreFeatures"
              header={'consultantLanding.moreFeatures'}
              content={'consultantLanding.openAccess'}
              icon="stars"
            />
            <Feature
              key="consultantLanding.moreLearning"
              header="consultantLanding.moreLearning"
              content={'consultantLanding.moreAdvancedVideos'}
              icon="video"
            />
            <Feature
              key="consultantLanding.meritBased"
              header="consultantLanding.meritBased"
              content={
                <div>
                  <FormattedMessageHelper id="consultantLanding.compensationOpportunity" />
                  <ul>
                    <li>
                      <FormattedMessageHelper id="consultantLanding.compensationOpportunity.grandmaster" />
                    </li>
                    <li>
                      <FormattedMessageHelper id="consultantLanding.compensationOpportunity.master" />
                    </li>
                  </ul>
                </div>
              }
              icon="money"
            />
            <Feature
              key="consultantLanding.career"
              header="consultantLanding.career"
              content="consultantLanding.internships"
              icon="stairs"
            />
            <Feature
              key="consultantLanding.exclusiveEvents"
              header={'consultantLanding.exclusiveEvents'}
              content={'consultantLanding.consultantCompetitions'}
              icon="gift"
            />
          </div>
        </div>
        {isLoggedIn && <ComparisonTable />}
        <div className="consultant-landing__section-divider"></div>
      </div>
    </div>
  );
}

interface FeatureProps {
  header: string;
  content: string | React.ReactNode;
  icon: string;
}
function Feature({ header, content, icon }: FeatureProps) {
  return (
    <div className="consultant-landing__feature">
      <div className={addModifiers('consultant-landing__feature-icon', [icon])}></div>
      <div className="consultant-landing__feature-header">
        <FormattedMessageHelper id={header} />
      </div>
      <div className="consultant-landing__feature-text">
        {typeof content === 'string' ? <FormattedMessageHelper id={content} /> : content}
      </div>
    </div>
  );
}

function ComparisonTable() {
  return (
    <div className="consultant-landing__comparison-table-container">
      <table className="consultant-landing__comparison-table">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>
              <FormattedMessageHelper id="consultantLanding.users" />
            </th>
            <th>
              <FormattedMessageHelper id="consultantLanding.consultants" />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th rowSpan={3} className="consultant-landing__th--darker">
              <FormattedMessageHelper id="consultantLanding.compensation" />
            </th>
            <th>
              <FormattedMessageHelper id="consultantLanding.basePayment" />
            </th>
            <td>
              <div className="consultant-landing__icon-cross" />
            </td>
            <td>
              <div className="consultant-landing__icon-check" />
            </td>
          </tr>
          <tr>
            <th>
              <FormattedMessageHelper id="consultantLanding.quarterlyPayment" />
            </th>
            <td>
              <div className="consultant-landing__icon-cross" />
            </td>
            <td>
              <div className="consultant-landing__icon-check" />
            </td>
          </tr>
          <tr>
            <th>
              <FormattedMessageHelper id="consultantLanding.referralProgram" />
            </th>
            <td>
              <div className="consultant-landing__icon-cross" />
            </td>
            <td>
              <div className="consultant-landing__icon-check" />
            </td>
          </tr>

          <tr>
            <th rowSpan={1} className="consultant-landing__th--lighter">
              <FormattedMessageHelper id="consultantLanding.submissionTests" />
            </th>
            <th>
              <FormattedMessageHelper id="consultantLanding.isPeriod" />
            </th>
            <td>
              <FormattedMessageHelper id="consultantLanding.5years" />
            </td>
            <td>
              <FormattedMessageHelper id="consultantLanding.10years" />
            </td>
          </tr>

          <tr>
            <th rowSpan={2} className="consultant-landing__th--darker">
              <FormattedMessageHelper id="consultantLanding.datasets" />
            </th>
            <th>
              <FormattedMessageHelper id="consultantLanding.regions" />
            </th>
            <td>
              <FormattedMessageHelper id="consultantLanding.userRegions" />
            </td>
            <td>
              <FormattedMessageHelper id="consultantLanding.consultantRegions" />
            </td>
          </tr>
          <tr>
            <th>
              <FormattedMessageHelper id="consultantLanding.dataFields" />
            </th>
            <td>
              <FormattedMessageHelper id="consultantLanding.userDataFields" />
            </td>
            <td>
              <FormattedMessageHelper id="consultantLanding.consultantDataFields" />
            </td>
          </tr>

          <tr>
            <th rowSpan={3} className="consultant-landing__th--lighter">
              <FormattedMessageHelper id="consultantLanding.otherFunctions" />
            </th>
            <th>
              <FormattedMessageHelper id="consultantLanding.multiSimulation" />
            </th>
            <td>
              <div className="consultant-landing__icon-cross" />
            </td>
            <td>
              <div className="consultant-landing__icon-check" />
            </td>
          </tr>
          <tr>
            <th>
              <FormattedMessageHelper id="consultantLanding.superAlphas" />
            </th>
            <td>
              <div className="consultant-landing__icon-cross" />
            </td>
            <td>
              <div className="consultant-landing__icon-check" />
            </td>
          </tr>
          <tr>
            <th>
              <FormattedMessageHelper id="consultantLanding.visualization" />
            </th>
            <td>
              <div className="consultant-landing__icon-cross" />
            </td>
            <td>
              <div className="consultant-landing__icon-check" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
